import { Grid, StyledEngineProvider, ThemeProvider } from "@mui/material";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Header from "./components/Header/Header";
import NotFound from "./pages/NotFound/NotFound";
import SharepointUrlSearch from "./pages/SharepointUrlSearch/SharepointUrlSearch";
import { theme } from "./theme";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import ReduxToastr from "react-redux-toastr";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { InteractionType, IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "./utils/NavigationClient";
import { loginRequest } from "./authConfig";
import { Loading } from "./components/Loading/Loading";
import { ErrorComponent } from "./components/ErrorComponent/ErrorComponent";

const routes = (
  <Routes>
    <Route path="/" element={<SharepointUrlSearch />} />
    <Route path="/404" element={<NotFound />} />

    {/* Only match when no other routes match */}
    <Route path="*" element={<Navigate to="/404" />} />
  </Routes>
);

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
  const history = useNavigate();
  const navigationClient = new CustomNavigationClient(history);
  pca.setNavigationClient(navigationClient);

  const authRequest = {
    ...loginRequest
  };

  return (
    <MsalProvider instance={pca}>
      <ThemeProvider theme={theme}>
        <StyledEngineProvider>
          <ReduxToastr timeOut={4000} newestOnTop={false} preventDuplicates position="top-right" transitionIn="fadeIn" transitionOut="fadeOut" progressBar closeOnToastrClick />
          <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest} errorComponent={ErrorComponent} loadingComponent={Loading}>
            <Grid container justifyContent={"center"}>
              <Grid item xs md={7}>
                <Grid item component={Header}></Grid>
                <Grid item p={1}>
                  {routes}
                </Grid>
              </Grid>
            </Grid>
          </MsalAuthenticationTemplate>
        </StyledEngineProvider>
      </ThemeProvider>
    </MsalProvider>
  );
}

export default App;
